import React from 'react';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import ToolbarPopup from '../../../toolbarPopup/ToolbarPopup';
import CellTypePopup from '../../../../../../element/table/legacy/cellTypes/CellTypePopup';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';

type LegacyCellTypePopupContainerProps = {
    isPopupOpen: boolean;
    buttonSelector: string;
    selectedElements: Immutable.List<ImMNElement>;
    closePopup: () => void;
    showArrow?: boolean;
    lastClickedType: string;
    setLastClickedType: (type: string) => void;
    locale: string;
    allSelectedCells: Array<{ row: number; col: number }>;
    activeCellType: string;
};

const LegacyCellTypePopupContainer: React.FC<LegacyCellTypePopupContainerProps> = ({
    isPopupOpen,
    selectedElements,
    ...props
}) => {
    const selectedElement = selectedElements.first();
    return (
        <ToolbarPopup
            {...props}
            popupId={PopupIds.CELL_TYPE}
            ignoredClicksSelector=".CustomSelectInput, .select-option"
            className="CellTypePopup LegacyCellTypePopup"
            showArrow={true}
        >
            <CellTypePopup {...props} closePopup={null} element={selectedElement} />
        </ToolbarPopup>
    );
};

export default LegacyCellTypePopupContainer;
